import { app } from '../bootstrap/core';
import { clearErrorHook } from '@fino/ng1-error-handling/lib';
import { redirectTo, requiresAuth, requiresStage } from '@fino/ng1-hooks';

// Register hooks
clearErrorHook(app);

app.run(redirectTo);
app.run(requiresAuth);
app.run(requiresStage);
